'use client';

import {
  isCryptoTransferTransaction,
  transactionTypeByTypeName,
} from '../types/transactions';
import { CryptoTransferDetailsDrawer } from '../../crypto-transfer-details/CryptoTransferDetailsDrawer/CryptoTransferDetailsDrawer';
import { TransactionDetailsDrawer } from '../../transaction-details/TransactionDetailsDrawer/TransactionDetailsDrawer';
import { TransactionEntryType } from '../utils/transactionTypesUtils';
import { OpenDrawerFunction } from '../../common/components/ModalDrawerContext/ModalDrawerContext';

export const openTransactionDetailsDesktopDrawer = (
  transaction: TransactionEntryType,
  openDrawer: OpenDrawerFunction,
) => {
  const { __typename, id, parentId, asset, category } = transaction;

  const title = asset?.name;

  let transactionTypeKey = __typename;

  const isFiatDeposit = category === 'FIAT_TRANSFER';

  if (isFiatDeposit) {
    transactionTypeKey += 'FiatTransfer';
  }

  const transactionType =
    transactionTypeByTypeName[
      transactionTypeKey as keyof typeof transactionTypeByTypeName
    ] || __typename;

  if (isCryptoTransferTransaction(transactionType)) {
    openDrawer(CryptoTransferDetailsDrawer, {
      cryptoTransferId: parentId,
      title,
    });

    return;
  }

  openDrawer(TransactionDetailsDrawer, {
    tradeId: isFiatDeposit ? id : parentId,
    title,
    transactionType,
  });
};
